import { render } from "./DynamicHtmlSpan.vue?vue&type=template&id=79136e4c&ts=true"
import script from "./DynamicHtmlSpan.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlSpan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlSpan.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79136e4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79136e4c', __exports__)) {
    api.reload('79136e4c', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlSpan.vue?vue&type=template&id=79136e4c&ts=true", () => {
    api.rerender('79136e4c', render)
  })

}


export default __exports__